
// project imports
import DrawerHeaderStyled from './DrawerHeaderStyled';
import Logo from 'components/logo';

// ==============================|| DRAWER HEADER ||============================== //

interface DrawerHeaderProps {
  open: boolean;
}

export default function DrawerHeader({ open }: DrawerHeaderProps) {
  return (
    <DrawerHeaderStyled
      open={open}
      sx={{
        px: 3,
        mt : 3,
        minHeight: '60px',
        width: 'initial',
        paddingInlineStart: open ? '24px' : 0  // Logical: left in LTR, right in RTL
      }}
    >
        <Logo isIcon={!open} sx={{ width: open ? 'auto' : 35, height: 35 }} />
    </DrawerHeaderStyled>
  );
}

